import React from 'react';
import {AccentColorProps} from 'epic-ue-theme';
import {
    Button,
    ButtonProps,
    CmsButtonProps,
    CmsComponentMapper,
    CmsDynamicArray,
    PlayIcon
} from '..';
import {LightboxButton, LightboxButtonProps} from './LightboxButton';

export type LightboxButtonPropsOptions = LightboxButtonProps | ButtonProps;
export type LightboxButtonPropsOptionsArray = CmsDynamicArray<LightboxButtonPropsOptions>;

export const BasicLightboxButton = ({
    href,
    label,
    accentColor
}: CmsButtonProps & AccentColorProps): JSX.Element => {
    return (
        <Button type="tertiary" startIcon={<PlayIcon />} href={href} color={accentColor}>
            {label}
        </Button>
    );
};

interface LightboxButtonOptionsProps {
    buttonOptions: LightboxButtonPropsOptionsArray;
}

export const LightboxButtonOptions = ({
    buttonOptions,
    accentColor
}: LightboxButtonOptionsProps & AccentColorProps): JSX.Element => {
    return (
        <CmsComponentMapper
            dynamicPageDataArray={buttonOptions}
            elementMapping={{
                button: <BasicLightboxButton accentColor={accentColor} />,
                lightbox: <LightboxButton accentColor={accentColor} />
            }}
        />
    );
};
